/**
 * The heading above a group of things, everywhere in the application.
 *
 * Small, spaced and upper-case rather than large: the brandbook reserves
 * all-caps for exactly this — notations and eyebrows, lightly tracked — and a
 * heading that competes with its own content for attention is the thing this
 * shape exists to avoid.
 *
 * **It lives here rather than in a feature.** It was defined in
 * `workspace-overview`'s private style module and imported by four other
 * feature packages, which is a cross-package reach into something never meant
 * to be public. Three more surfaces rolled their own instead — two at
 * `text-sm font-medium`, one a near-miss at `font-medium tracking-wide` — and
 * a near-miss is the worst outcome: it reads as a mistake rather than as a
 * different kind of heading.
 */
export const SECTION_HEADING =
  'text-muted-foreground text-xs font-semibold tracking-wider uppercase';
